import { render, staticRenderFns } from "./productLicenseToList.vue?vue&type=template&id=9bd459f4&scoped=true"
import script from "./productLicenseToList.vue?vue&type=script&lang=js"
export * from "./productLicenseToList.vue?vue&type=script&lang=js"
import style0 from "./productLicenseToList.vue?vue&type=style&index=0&id=9bd459f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd459f4",
  null
  
)

export default component.exports